'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'explosion';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4e9';
var svgPathData = 'M304 16l0 80-32 0 0-96 32 0 0 16zM16 480l177.3 0c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80l193.3 0 0 32-576 0 0-32 16 0zm210 0l124 0c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48zM75.9 347.7c10.2 .9 27.6 2.3 52.1 4.3-2.8-14-10.3-51.3-22.4-112L96 192c19.4 15.1 57.9 45 115.5 89.8L240 304c1.1-6.2 11.8-64.9 32-176l32 0c18.1 90.5 28.8 143.9 32 160l25.6-35.4C460.3 115.9 521.1 31.7 544 0 534.6 34.6 505.5 141 457 319.1L448 352c51.9-4.3 60.2-5 96-8-15.8 19.7-39.3 49.1-70.4 88l-41 0 39.9-49.9c-10.7 .9-33.2 2.8-67.5 5.6 1.8-6.4 22.3-81.8 61.7-226.1-80.2 111-129.4 179.2-147.8 204.6-9.3-46.7-19.4-97.1-30.3-151.3-12.8 70.4-21.7 119.4-26.7 146.8-22.1-17.2-61.3-47.7-117.8-91.6 11.2 56.1 19 95.2 23.5 117.4-31.7-2.6-53.1-4.4-64.3-5.4l39.9 49.9-41 0C71.3 393.1 47.8 363.7 32 344l43.9 3.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faExplosion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;